import { useState, useCallback } from 'react';
import { useIntl } from 'react-intl';

const usePCPForm = initialPCPAnswer => {
  const [pcpAnswer, setPcpAnswer] = useState(initialPCPAnswer || null);

  const { formatMessage } = useIntl();

  const answers = {
    Y: formatMessage({ id: 'common.yes' }),
    N: formatMessage({ id: 'common.no' }),
    U: formatMessage({ id: 'common.preferNotToSay' }),
  };

  const optionsList = Object.entries(answers).map(([k, v]) => ({
    label: v,
    value: k,
  }));

  const handleOptionChange = useCallback(value => {
    setPcpAnswer(value);
  }, []);

  return { pcpAnswer, handleOptionChange, optionsList };
};

export default usePCPForm;



// WEBPACK FOOTER //
// ./src/components/forms/PrimaryCareProviderForm/hooks/usePCPForm.js